import request from 'lib/request'

export function trackTimeTillInteractive(page) {
  const duration = window.performance.now()

  if (window.performance.mark) {
    window.performance.mark('time_till_interactive')
    // https://www.w3.org/TR/user-timing/#ut-standard-mark-names
    window.performance.mark('mark_fully_loaded')
  }

  if (window.performance.measure) {
    window.performance.measure('time_till_interactive')
  }

  request('/api/stats/tti', {
    method: 'POST',
    body: JSON.stringify({ duration, page })
  })
}

/**
 * Supported types of app-crashes
 */
export const TRANSACTIONAL_CRASH = 'transactional'
export const JAVASCRIPT_CRASH = 'javascript'
export const GRAPHQL_CRASH = 'graphql'
export const SLOTH_CRASH = 'sloth-of-death'

/**
 * Capture crash metrics via gateway-api's `app-crash` rest endpoint
 * @param {Object} attributes - a set of attributes associated with a crash
 * @param {string} [attributes.componentName] - a component associated with the crash
 * @param {string} [attributes.route] - the current page's route
 * @param {string} [attributes.team] - the team associated with the part of the app that crashed
 * @param {string} [attributes.type] - the type of crash, one of ['transactional','javascript','graphql','sloth-of-death']
 * @returns {Promise} - request promise
 */
export function trackAppCrash({ componentName, route, type, team } = {}) {
  return request(`/api/rest/stats/app-crash/${type}`, {
    method: 'POST',
    body: JSON.stringify({
      componentName,
      route,
      team
    })
  })
}
